
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningUnacknowledgedIec as ObiWarningUnacknowledgedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-unacknowledged-iec.js';
 
 
 

 
 export const ObiWarningUnacknowledgedIec = createComponent({
   react: React,
   tagName: 'obi-warning-unacknowledged-iec',
   elementClass: ObiWarningUnacknowledgedIecElement,
   events: {
     
   }
  });
 
 